import { VtmnTooltip } from '@vtmn/react'
import { VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { ITeamsByStoreId } from 'core/models/api/team/team'

interface ProductivityTitleProps {
  isInstore: boolean
  isTeam: boolean
  team?: ITeamsByStoreId
}

const getTooltipTranslationKey = (isInstore: boolean, isTeam: boolean, team?: ITeamsByStoreId) => {
  if (isInstore) {
    if (isTeam) {
      return team?.team_type === 'COMMERCIAL'
        ? 'general.homepage.target-productivity.tooltip.instore-commercial-team'
        : 'general.homepage.target-productivity.tooltip.instore-cash-team'
    }
    return 'general.homepage.target-productivity.tooltip.instore-store'
  }
  return 'general.homepage.target-productivity.tooltip.omni-store'
}

const ProductivityTitle = ({ isInstore, isTeam, team }: ProductivityTitleProps) => {
  const { t } = useTranslation()

  return (
    <div className="vp-caption productivity-title">
      {t('general.homepage.productivity')}
      <VtmnTooltip position="top-left" tooltip={t(getTooltipTranslationKey(isInstore, isTeam, team))}>
        <VpIcon {...({ name: 'information', size: 22 } as any)} />
      </VtmnTooltip>
    </div>
  )
}

export default ProductivityTitle
